import { Injectable, EventEmitter } from '@angular/core';
import { Alert } from './Alert';
import { Location } from '@angular/common';

@Injectable()
export class AlertsService {
	private _alerts: Alert[] = [];
	private _alertEmitter: EventEmitter<Alert[]>;

	constructor(
		location: Location
	) {
		location.subscribe(() => {
			this._alerts = [];
		});
		this._alertEmitter = new EventEmitter<Alert[]>();
	}

	get alerts() {
		return this._alerts;
	}

	closeAlert(alertNumToClose = 0): Alert[] {
		let removed: Alert[] = [];

		if (alertNumToClose < this._alerts.length) {
			removed = this._alerts.splice(alertNumToClose, 1);
		}
		this._alertEmitter.next(this._alerts);
		return removed;
	}

	closeAlertByRef(alertToClose: Alert): Alert[] {
		let removed: Alert[] = [];

		const alertIdx: number = this._alerts.indexOf(alertToClose);
		if (alertIdx >= 0) {
			removed = this._alerts.splice(alertIdx, 1);
		}
		this._alertEmitter.next(this._alerts);
		return removed;
	}

	getAlerts(namespace: string = null): Alert[] {
		let alerts: Alert[] = this._alerts;
		if (namespace) {
			alerts = this._alerts.filter(
				(alertObj) => {
					return alertObj.namespace === namespace;
				}
			);
		}
		return alerts;
	}

	addAlertIfNotActive(alert: Alert): void {
		if (!this._alerts.find( (elert: Alert) => { return elert.id === alert.id; })) {
			this.addAlert(alert);
		}
	}

	addAlert(alertToAdd: Alert) {
		this._alerts.push(alertToAdd);
		if (alertToAdd.timeout) {
			setTimeout(() => {
				this.closeAlertByRef(alertToAdd);
			}, alertToAdd.timeout);
		}
		this._alertEmitter.next(this._alerts);
	}

	subscribeToAlerts(func: (alerts: Alert[]) => void): void {
		this._alertEmitter.subscribe(func);
	}

	clearAlerts(namespace: string = null) {
		if (this._alerts && this._alerts.length > 0) {
			if (namespace) {
				this._alerts = this._alerts.filter(
					(alertObj) => {
						return alertObj.namespace !== namespace;
					}
				);
			} else {
				this._alerts = [];
			}
		}
	}
}
